import { render } from "./rke2.vue?vue&type=template&id=8454328c&scoped=true"
import script from "./rke2.vue?vue&type=script&lang=js"
export * from "./rke2.vue?vue&type=script&lang=js"

import "./rke2.vue?vue&type=style&index=0&id=8454328c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8454328c"]])

export default __exports__